export function sleepFor(milliseconds: number) {
    return new Promise<void>((resolve) => setTimeout(resolve, milliseconds))
}
